/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cropaspectoriginal2Inputs */

const en_cropaspectoriginal2 = /** @type {(inputs: Cropaspectoriginal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Original`)
};

const de_cropaspectoriginal2 = /** @type {(inputs: Cropaspectoriginal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Original`)
};

/**
* | output |
* | --- |
* | "Original" |
*
* @param {Cropaspectoriginal2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cropaspectoriginal2 = /** @type {((inputs?: Cropaspectoriginal2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cropaspectoriginal2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cropaspectoriginal2(inputs)
	return de_cropaspectoriginal2(inputs)
});
export { cropaspectoriginal2 as "cropAspectOriginal" }